// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oKD28","comment":"styles_comment__xOydh"};